// Libs
import React, { PureComponent } from 'react'
import _find from 'lodash/find'
import _get from 'lodash/get'
import _size from 'lodash/size'

// Types
import type {
  Asset,
} from 'fc-model-assets/types'

// Components
import Select from 'react-select'
import FormField from '@react-mdc/form-field'
import ShapeSvg from 'fc-components-shapes/src/ShapeSvg'

// Constants
import {
  PROP_ASSET_ID,
} from 'fc-model-assets'

// Local Functions
function onChange (cb: Function): Function {
  return function (option: ?{ value: number }) {
    if (option) {
      cb(option.value || null)
      return
    }

    cb(null)
  }
}

// Local Styles
const styles = {
  container: {
    marginTop: '15px',
  },
}

// Local Components
function makeFieldSelectorOption ({getFields}: { getFields: Function }): Function {
  return ({value: fieldId, label}: { value: number, label: string }): React.Element<any> => {
    const field: Asset = _find(getFields(), { [PROP_ASSET_ID]: fieldId }) || {}

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{
          flex: '1 1 auto',
        }}>{label}</div>
        {_get(field, 'shape.shapeData.features.length') > 0 && <div style={{
          flex: '0 0 45px',
        }}>
          <ShapeSvg shape={field.shape} />
        </div>}
      </div>
    )
  }
}

// Props
export type Props = {
  fields: Array<Asset>,
  selectedSeasonId: ?number,
  selectedFarmId: ?number,
  selectedFieldId: ?number,
  seasonSelectorOptions: Array<{ id: number, value: string }>,
  farmSelectorOptions: Array<{ id: number, value: string }>,
  fieldSelectorOptions: Array<{ id: number, value: string }>,
  children: ?React.element<any>,
  onChangeSeason: Function,
  onChangeFarm: Function,
  onChangeField: Function,
  centerMapToFarm: Function,
  centerMapToField: Function,
}

// Exports
export default class PanelAssetsForm extends PureComponent {
  props: Props

  constructor (props: Props) {
    super(props)

    this.fieldOptionRenderer = makeFieldSelectorOption({
      getFields: (): Array<Asset> => this.props.fields,
    })
    this.handleFarmChange = this.handleFarmChange.bind(this)
    this.handleFieldChange = this.handleFieldChange.bind(this)
  }

  handleFarmChange (e: Event) {
    const farmId = e ? e.value : null

    onChange(this.props.onChangeFarm)(e)
    this.props.centerMapToFarm({ farmId, seasonId: this.props.selectedSeasonId })
  }

  handleFieldChange (e: Event) {
    const fieldId = e ? e.value : null

    onChange(this.props.onChangeField)(e)
    this.props.centerMapToField(fieldId)
  }

  render () {
    return (
      <div style={styles.container} className='select-group-aligned-right w80'>
        <FormField>
          <label htmlFor='season-selector'>Season</label>
          <Select
            name='season-selector'
            placeholder={'Seasons'}
            value={this.props.selectedSeasonId}
            disabled={!_size(this.props.seasonSelectorOptions)}
            options={this.props.seasonSelectorOptions}
            onChange={onChange(this.props.onChangeSeason)}
            className='clear-margin'
          />
        </FormField>
        <FormField>
          <label htmlFor='farm-selector'>Farm</label>
          <Select
            name='farm-selector'
            placeholder={'Farms'}
            value={this.props.selectedFarmId}
            disabled={!_size(this.props.farmSelectorOptions)}
            options={this.props.farmSelectorOptions}
            onChange={this.handleFarmChange}
            className='clear-margin'
          />
        </FormField>
        <FormField>
          <label htmlFor='field-selector'>Field</label>
          <Select
            name='field-selector'
            placeholder={'Fields'}
            value={this.props.selectedFieldId}
            disabled={!_size(this.props.fieldSelectorOptions)}
            options={this.props.fieldSelectorOptions}
            onChange={this.handleFieldChange}
            optionRenderer={this.fieldOptionRenderer}
            className='clear-margin'
          />
        </FormField>
        {this.props.children}
      </div>
    )
  }
}
